import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextBoxGroup from '../text-box-group/text-box-group';
import Button from '../button/button';
import { AcceptIcon, EditIcon } from '../icons/icons';

function TitleEditable({
  value,
  onChange,
  placeholder,
  isValidProductName,
  isEditingValid,
  setHasUnsavedProductName,
}) {
  const [isToggle, setIsToggle] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e) => {
    const val = e?.target?.value || '';
    setInputValue(val);
    setHasUnsavedProductName(true);
    isEditingValid(
      !!val?.trim() && /[a-zA-Z0-9]/.test(val) && isValidProductName(val)
    );
  };

  useEffect(() => {
    setIsToggle(!value);
  }, [value]);

  const isDisabled =
    !inputValue ||
    inputValue?.trim() === '' ||
    !/[a-zA-Z0-9]/.test(inputValue) ||
    !isValidProductName(inputValue);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSave = () => {
    const event = {
      target: {
        name: 'name',
        value: inputValue,
      },
    };

    onChange(event);
    setHasUnsavedProductName(false);
    setIsToggle(false);
  };

  return (
    <>
      {!isToggle && <h4 className="text-limit mw-200">{inputValue} </h4>}
      {isToggle && (
        <TextBoxGroup
          className="mb-0"
          name="newPackage"
          placeholder={placeholder}
          type="text"
          value={inputValue}
          onChange={handleChange}
          autoFocus
        />
      )}
      {!isToggle ? (
        <Button
          styles="icon"
          className="px-10"
          icon={<EditIcon size="1.25vw" color="#0288FA" />}
          onClick={() => setIsToggle(true)}
        />
      ) : (
        <Button
          styles="icon"
          className="px-10"
          icon={<AcceptIcon size="1.25vw" color="#0288FA" />}
          onClick={handleSave}
          disabled={isDisabled}
        />
      )}
    </>
  );
}

export default TitleEditable;
TitleEditable.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  isValidProductName: PropTypes.func,
  isEditingValid: PropTypes.func,
  setHasUnsavedProductName: PropTypes.func,
};
TitleEditable.defaultProps = {
  value: '',
  onChange: () => {},
  placeholder: '',
  isValidProductName: () => true,
  isEditingValid: () => {},
  setHasUnsavedProductName: () => {},
};
